module.exports = new __parcel__URL__("titan2.4b42c336.png").toString();